namespace GeniuzPOS.ReportMasterData {
    export class Report_1201Columns {
        static columnsKey = 'ReportMasterData.Report_1201';
    }
}
